import { createContext } from 'react';
import type { AuthContextType } from '@/types/application/common/context/portal-context-model';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
